module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "agency form-page"
  }, [_c('div', {
    staticClass: "agency-main",
    staticStyle: {
      "padding-bottom": "70px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasResp && _vm.baseInfo.stepCurrent),
      expression: "hasResp && baseInfo.stepCurrent"
    }],
    staticClass: "propress-line",
    staticStyle: {
      "padding": "32px 0",
      "background": "#fff"
    }
  }, [_c('my-step', {
    attrs: {
      "step": _vm.baseInfo.stepCurrent,
      "totalstep": _vm.baseInfo.stepTotal
    }
  })], 1), _vm._v(" "), _c('div', [_c('group', {
    attrs: {
      "title": "投资者基本信息",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "orgName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "机构名称",
      "placeholder": "请输入机构名称",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgName),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgName", $$v)
      },
      expression: "propData.orgName"
    }
  }), _vm._v(" "), _c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "机构类型",
      "options": [],
      "placeholder": "请选择机构类型",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.orgType),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgType", $$v)
      },
      expression: "propData.orgType"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "证件类型",
      "options": [],
      "placeholder": "请选择证件类型",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.orgDocumentsType),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgDocumentsType", $$v)
      },
      expression: "propData.orgDocumentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgDocumentsNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件编号",
      "placeholder": "请输入证件编号",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgDocumentsNo),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgDocumentsNo", $$v)
      },
      expression: "propData.orgDocumentsNo"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效期",
      "max": 10,
      "keyboard": "number",
      "placeholder": "请输入有效期,如:2018-01-01",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.orgDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgDocumentsValidity", $$v)
      },
      expression: "propData.orgDocumentsValidity"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgQualificationProve",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "资质证书",
      "placeholder": "请输入资质证书",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgQualificationProve),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgQualificationProve", $$v)
      },
      expression: "propData.orgQualificationProve"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgQualificationNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证书编号",
      "keyboard": "number",
      "placeholder": "请输入证书编号",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgQualificationNo),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgQualificationNo", $$v)
      },
      expression: "propData.orgQualificationNo"
    }
  }), _vm._v(" "), _c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "经营范围",
      "options": [],
      "placeholder": "请选择经营范围",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.propData.orgBusinessScope),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgBusinessScope", $$v)
      },
      expression: "propData.orgBusinessScope"
    }
  }), _vm._v(" "), _c('x-textarea', {
    ref: "orgRegisterAddress",
    attrs: {
      "title": "注册地址",
      "autosize": "",
      "placeholder": "请输入办公地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgRegisterAddress),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgRegisterAddress", $$v)
      },
      expression: "propData.orgRegisterAddress"
    }
  }), _vm._v(" "), _c('x-textarea', {
    ref: "orgAddress",
    attrs: {
      "title": "办公地址",
      "autosize": "",
      "placeholder": "请输入办公地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgAddress),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgAddress", $$v)
      },
      expression: "propData.orgAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgRegisteredCapital",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "注册资本",
      "placeholder": "请输入注册资本（万元）",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgRegisteredCapital),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgRegisteredCapital", $$v)
      },
      expression: "propData.orgRegisteredCapital"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "orgController",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "股东或实际控股人",
      "placeholder": "请输入股东或实际控股人",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.propData.orgController),
      callback: function($$v) {
        _vm.$set(_vm.propData, "orgController", $$v)
      },
      expression: "propData.orgController"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('group', {
    attrs: {
      "title": "法定代表人或负责人",
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativeName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "placeholder": "请输入姓名",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeName),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeName", $$v)
      },
      expression: "twoData.representativeName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeDocumentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "value": _vm.iDCardTypesLabel(_vm.twoData.representativeDocumentsType),
      "placeholder": "请输入证件类型",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeIdCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "placeholder": "请输入证件号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeIdCardNo),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeIdCardNo", $$v)
      },
      expression: "twoData.representativeIdCardNo"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效期",
      "max": 10,
      "keyboard": "number",
      "placeholder": "请输入有效期,如:2018-01-01",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeDocumentsValidity", $$v)
      },
      expression: "twoData.representativeDocumentsValidity"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [(_vm.isForeign(_vm.propData.representativeDocumentsType)) ? _c('x-input', {
    ref: "legalCountry",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "国籍",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.propData.legalCountry),
      callback: function($$v) {
        _vm.$set(_vm.propData, "legalCountry", $$v)
      },
      expression: "propData.legalCountry"
    }
  }) : _vm._e(), _vm._v(" "), _c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0, 0.3)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.twoData.representativeSex),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeSex", $$v)
      },
      expression: "twoData.representativeSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeAge),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeAge", $$v)
      },
      expression: "twoData.representativeAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativePosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativePosition),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativePosition", $$v)
      },
      expression: "twoData.representativePosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeLanline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "placeholder": "格式：区号+座机号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeLanline),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeLanline", $$v)
      },
      expression: "twoData.representativeLanline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "placeholder": "请输入手机号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeMobile),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeMobile", $$v)
      },
      expression: "twoData.representativeMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "representativeEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeEmail),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeEmail", $$v)
      },
      expression: "twoData.representativeEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "5em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "representativeZip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公邮编",
      "max": 6,
      "type": "number",
      "placeholder": "请输入办公邮编",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeZip),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeZip", $$v)
      },
      expression: "twoData.representativeZip"
    }
  }), _vm._v(" "), _c('x-textarea', {
    ref: "representativeAddress",
    attrs: {
      "title": "办公地址",
      "autosize": "",
      "placeholder": "请输入办公地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.twoData.representativeAddress),
      callback: function($$v) {
        _vm.$set(_vm.twoData, "representativeAddress", $$v)
      },
      expression: "twoData.representativeAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('group', {
    attrs: {
      "title": "指定授权经办人",
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersName",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "姓名",
      "placeholder": "请输入姓名",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersName),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersName", $$v)
      },
      expression: "threeData.managersName"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersDocumentsType",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件类型",
      "text-align": "right",
      "placeholder": "请输入证件类型",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersDocumentsType),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersDocumentsType", $$v)
      },
      expression: "threeData.managersDocumentsType"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersIdCardNo",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "证件号码",
      "placeholder": "请输入证件号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersIdCardNo),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersIdCardNo", $$v)
      },
      expression: "threeData.managersIdCardNo"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersDocumentsValidity",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "有效期",
      "max": 10,
      "keyboard": "number",
      "placeholder": "请输入有效期,如:2018-01-01",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersDocumentsValidity),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersDocumentsValidity", $$v)
      },
      expression: "threeData.managersDocumentsValidity"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('selector', {
    style: ({
      color: _vm.baseInfo.type === 0 ? 'rgba(0, 0, 0, 0.3)' : '',
      height: _vm.baseInfo.type === 0 ? '30px' : '50px'
    }),
    attrs: {
      "title": "性别",
      "options": ['男', '女'],
      "placeholder": "请选择性别",
      "readonly": _vm.baseInfo.type === 0
    },
    model: {
      value: (_vm.threeData.managersSex),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersSex", $$v)
      },
      expression: "threeData.managersSex"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersAge",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "年龄",
      "type": "number",
      "placeholder": "请输入年龄",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": "",
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersAge),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersAge", $$v)
      },
      expression: "threeData.managersAge"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersPosition",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "职务",
      "placeholder": "请输入职务",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersPosition),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersPosition", $$v)
      },
      expression: "threeData.managersPosition"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersLanline",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(座机)",
      "max": 20,
      "keyboard": "number",
      "placeholder": "格式：区号+座机号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersLanline),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersLanline", $$v)
      },
      expression: "threeData.managersLanline"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersMobile",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电话(手机)",
      "max": 11,
      "keyboard": "number",
      "placeholder": "请输入手机号码",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersMobile),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersMobile", $$v)
      },
      expression: "threeData.managersMobile"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "managersEmail",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "电子邮箱",
      "placeholder": "请输入电子邮箱",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersEmail),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersEmail", $$v)
      },
      expression: "threeData.managersEmail"
    }
  })], 1), _vm._v(" "), _c('group', {
    attrs: {
      "label-width": "6em",
      "label-margin-right": "1em",
      "label-align": "left"
    }
  }, [_c('x-input', {
    ref: "managersZip",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "办公邮编",
      "max": 6,
      "type": "number",
      "placeholder": "请输入办公邮编",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersZip),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersZip", $$v)
      },
      expression: "threeData.managersZip"
    }
  }), _vm._v(" "), _c('x-textarea', {
    ref: "managersAddress",
    attrs: {
      "title": "办公地址",
      "autosize": "",
      "placeholder": "请输入办公地址",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.managersAddress),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "managersAddress", $$v)
      },
      expression: "threeData.managersAddress"
    }
  }), _vm._v(" "), _c('x-input', {
    ref: "relationshipWithOrg",
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "title": "与该机构关系",
      "placeholder": "请输入与该机构关系",
      "text-align": _vm.baseInfo.type === 0 ? 'right' : '',
      "disabled": _vm.baseInfo.type === 0,
      "required": ""
    },
    model: {
      value: (_vm.threeData.relationshipWithOrg),
      callback: function($$v) {
        _vm.$set(_vm.threeData, "relationshipWithOrg", $$v)
      },
      expression: "threeData.relationshipWithOrg"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "question-con"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isFund ? '一、私募基金投资者，最近20个交易日金融资产均不得低于人民币300万元，或者最近3年个人年均收入不低于人民币50万元' :
    '一、资产管理计划投资者，具有2年以上投资经历，且满足以下条件之一：家庭金融净资产不低于300万元，家庭金融资产不低于500万元，或者近3年本人年均收入不低于40万元') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.question.orgAssetsScale.checked))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("二、是否为下列机构")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px"
    }
  }, [_vm._v("\n          符合《证券期货投资者适当性管理办法》第八章第（一）款所规定的证券公司、期货公司、基金管理公司及其子公司、商业银行、保险公司、信托公司、财务公司；\n          或在中国证券投资基金业协会登记或者备案的证券公司子公司、期货公司子公司、私募基金管理人；或者第（三）款所规定的合格境外机构投资者（QFII），人名币合格境外机构投资者（RQFII）\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.question.isProfessionalInvestors.checked))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("三、是否存在实际控制关系？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.question.isControllingShareholder.checked))]), _vm._v(" "), (_vm.question.isControllingShareholder.checked === '是') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.question.isControllingShareholder.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("四、交易实际受益人？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.question.transactionActualBeneficiary.checked))]), _vm._v(" "), (_vm.question.transactionActualBeneficiary.checked === '其他机构或个人') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.question.transactionActualBeneficiary.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("五、是否有不良诚信记录？")]), _vm._v(" "), _c('div', {
    staticClass: "answer",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.question.isBadFaith.checked))]), _vm._v(" "), (_vm.question.isBadFaith.checked === '是') ? _c('span', [_vm._v("（原因：" + _vm._s(_vm.question.isBadFaith.description) + "）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "notice-text"
  }, [_vm._v("\n        以上资料为您的理财师在特定对象确认程序时向您获取并上传至系统用于适当性管理留痕，经您本人在线确认视为您对该材料真实、完整、准确、有效性的认可。若以上资料与您实际资料不符，请您联系理财师进行修改，确保您提供给理财师的资料真实、有效、准确、完整，并对您提供的资料承担责任。\n      ")])]), _vm._v(" "), (_vm.baseInfo.isShowBtn) ? _c('submit-button', {
    on: {
      "click": _vm.$_agency_submit
    }
  }, [_vm._v("确认")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11efb51c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Agency/OneLook.vue
// module id = 1018
// module chunks = 1